import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './authenticatedBaseQuery'

export const offerTags = [
  'OfferCounts',
  'Offers',
  'UpcomingOffers',
  'LiveOffers',
  'ExpiredOffers'
] as const

export const baseAPI = createApi({
  reducerPath: 'baseAPI',
  baseQuery: authenticatedBaseQuery,
  tagTypes: [
    'Profile',
    'Notifications',
    'NotificationsCount',
    'Venues',
    'Users',
    'Tags',
    'MailingLists',
    'EmailHistory',
    'EmailTemplates',
    'NotificationTemplates',
    'NotificationTemplateStats',
    'VenueDetails',
    'OfferTags',
    'ExperienceTags',
    'OfferCategoriesTags',
    'CuisineTags',
    'FoodTags',
    'DrinkTags',
    'ActivityTags',
    'VenueTypeTags',
    'TagOptions',
    'AuditLog',
    'AdminNotes',
    'Offers',
    ...offerTags
  ],
  // need to keep this as is for TS to not complain and endpoints to inject correctly
  endpoints: () => ({})
})
